module.exports = __webpack_public_path__ + "img/rank20.94da3fbb.png";